import React from "react";

export const Sparkline = ({ data = [], positive = true, width = 120, height = 36 }) => {
  if (!data || data.length < 2) {
    return <div style={{ width, height }} />;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data
    .map((v, i) => `${i * stepX},${height - ((v - min) / range) * height}`)
    .join(" ");
  const color = positive ? "var(--bull)" : "var(--bear)";

  return (
    <svg
      data-testid="sparkline-svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
      <polyline
        fill={color}
        fillOpacity="0.08"
        stroke="none"
        points={`0,${height} ${points} ${width},${height}`}
      />
    </svg>
  );
};
